import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Layout from './components/Layout';
import SubQuery from './routes/SubQuery';
import Subspace from './routes/Subspace';
import TheGraph from './routes/TheGraph';
import Celestia from './routes/Celestia';
import NotFound from './routes/NotFound';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<App />} />
          <Route path="subquery" element={<SubQuery />} />
          <Route path="subspace" element={<Subspace />} />
          <Route path="thegraph" element={<TheGraph />} />
          <Route path="celestia" element={<Celestia />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
